<template>
  <home-layout>
    <header-info></header-info>
    <div class="container-fluid hero">
      <div class="hero__content">
        <a href="#" class="back__to">
          <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6157 16.8936L15.042 15.4672L11.2626 11.6878L15.042 7.90839L13.6157 6.48205L8.40624 11.6878L13.6157 16.8936Z" fill="#CAEEDD"/>
          </svg>
          <span>Propiedades > {{ propertyValue.title }}</span>
        </a>
        <div class="hero__background  d-xl-none d-lg-none d-block">
          <button type="button" class="btn more-images" data-toggle="modal" data-target="#exampleModal">
            Ver Imágenes
          </button>
          <img class="hero__image" :src="propertyValue.img" alt="594 Columbia Ave" />
          <!--img class="hero__image" :src="propertyValue.img" alt="594 Columbia Ave" /-->
          <!--section class="carousel___init" aria-label="Gallery">
              <ol class="carousel__viewport">
                <li class="carousel__slide" v-for="(item, index) in images" :key="index"  :id="'carousel__slide'+index">
                    <img class="hero__image" :src="item.attributes.url" alt="594 Columbia Ave" />
                    <div class="carousel__snapper">
                    <a :href="'#carousel__slide'+ (index == 0 ? images.length - index : index - 1)"
                      class="carousel__prev">Go to last slide</a>
                    <a :href="'#carousel__slide'+ (index == (images.length - 1) ? 0 : index + 1)"
                      class="carousel__next">Go to next slide</a>
                  </div>
                </li>
              </ol>
              <aside class="carousel__navigation">
                <ol class="carousel__navigation-list">
                  <li v-for="(item, index) in images.length" :key="index"  :id="'carousel__slide'+index" class="carousel__navigation-item">
                    <a :href="'#carousel__slide'+index"
                      class="carousel__navigation-button">Go to slide 1</a>
                  </li>
                </ol>
              </aside>
            </section-->
        </div>
        <div class="property__info">
          <div class="property__detail">
            <h1 class="property__address"> {{ propertyValue.title }}</h1>
            <span class="property__address__2"> {{ propertyValue.add }}</span>
            <span class="property__status">{{ propertyValue.Status ? 'Activa' : 'Inactiva' }}</span>
          </div>
          <div class="property__features">
            <div class="property__features__list">
              <div class="property__features__list-item">
                <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1238_3859)">
                    <path d="M10.6041 1.74983V5.70743M10.6042 7.68613V10.3245C10.6042 10.6888 10.2568 10.9841 9.82818 10.9841H2.06821M23.0202 12.3033H15.2602C14.8317 12.3033 14.4842 12.5986 14.4842 12.9629V19.5589M16.4241 1.41992C16.4241 4.33422 19.2035 6.69673 22.6322 6.69673M3.62017 1.42H20.6922C21.7636 1.42 22.6322 2.15828 22.6322 3.069V17.5802C22.6322 18.4909 21.7636 19.2292 20.6922 19.2292H3.62017C2.54874 19.2292 1.68018 18.4909 1.68018 17.5802V3.069C1.68018 2.15828 2.54874 1.42 3.62017 1.42Z" stroke="currentColor" stroke-width="2"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1238_3859">
                      <rect width="24" height="20.4" fill="white" transform="translate(0.15625 0.399902)"/>
                    </clipPath>
                  </defs>
                </svg>
                <span class="list__item-name">{{ propertyValue.size }} mt<sup>2</sup></span>
              </div>
              <div class="property__features__list-item">
                <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1238_3876)">
                    <path d="M16.8781 12.6369H16.8785C17.6147 12.6369 18.3364 12.4515 18.9526 12.1015C19.5689 11.7514 20.0547 11.2508 20.3432 10.6589C20.632 10.0662 20.7084 9.41154 20.5604 8.77951C20.4127 8.14804 20.0491 7.57319 19.5222 7.12527C18.9955 6.6776 18.328 6.37551 17.6055 6.25334C16.8829 6.13117 16.1336 6.19368 15.4514 6.43387C14.7692 6.67406 14.1812 7.0825 13.7649 7.61203C13.3482 8.1421 13.1229 8.76943 13.1229 9.41469L13.1229 9.41528C13.1255 10.2805 13.5312 11.1016 14.2374 11.7019C14.9426 12.3014 15.8924 12.6348 16.8781 12.6369ZM15.4896 12.9669V12.9667L15.4798 12.9672C15.3589 12.9731 15.2383 12.9836 15.1185 12.9985C14.7723 12.4839 14.28 12.0552 13.6901 11.7508C13.0584 11.4248 12.3364 11.2523 11.6013 11.25H11.6007H6.04514C4.97025 11.25 3.93413 11.6126 3.16575 12.2657C2.39638 12.9197 1.95625 13.8143 1.95625 14.7555V19.4777C1.95625 19.6675 2.04519 19.8414 2.18944 19.964C2.3327 20.0858 2.52098 20.15 2.71181 20.15H21.6007C21.7915 20.15 21.9798 20.0858 22.1231 19.964C22.2673 19.8414 22.3562 19.6675 22.3562 19.4777V16.4725C22.3562 15.5313 21.9161 14.6367 21.1468 13.9827C20.3784 13.3296 19.3422 12.9669 18.2674 12.9669H15.4896ZM15.6896 14.7547C15.689 14.6063 15.6774 14.4583 15.655 14.3114H18.2674C18.9606 14.3114 19.6202 14.5458 20.102 14.9553C20.5829 15.3641 20.8451 15.9108 20.8451 16.4725V18.8055H15.6896L15.6896 14.7555L15.6896 14.7547ZM8.82292 10.7055C9.73492 10.7055 10.6285 10.4757 11.3909 10.0427C12.1534 9.60968 12.7531 8.99105 13.1088 8.26104C13.4649 7.5303 13.5589 6.72374 13.3767 5.94515C13.1946 5.16712 12.7464 4.45763 12.0951 3.90405C11.4442 3.35071 10.6183 2.97666 9.72333 2.82534C8.82829 2.67401 7.9003 2.75149 7.05568 3.04887C6.21106 3.34624 5.48419 3.85153 4.97026 4.50531C4.45591 5.15962 4.17847 5.93303 4.17847 6.72773C4.17847 7.79416 4.67713 8.80889 5.55069 9.55141C6.42326 10.2931 7.60069 10.7055 8.82292 10.7055ZM8.82292 4.0944C9.44921 4.0944 10.0594 4.25238 10.576 4.54581C11.0926 4.83918 11.4898 5.25306 11.7227 5.73107C11.9553 6.20836 12.0154 6.73107 11.8975 7.23491C11.7794 7.73931 11.4869 8.20782 11.0504 8.57881C10.6137 8.95006 10.0536 9.20565 9.43988 9.30942C8.82617 9.41318 8.1903 9.35974 7.61372 9.15674C7.03714 8.95373 6.54929 8.61165 6.20859 8.17825C5.86831 7.74537 5.68958 7.24059 5.68958 6.72773C5.68958 6.04079 6.01037 5.37395 6.59542 4.87665C7.18147 4.37851 7.98235 4.0944 8.82292 4.0944ZM16.8788 7.52841C17.3292 7.52847 17.7674 7.64214 18.1378 7.85249C18.5081 8.06284 18.7914 8.35872 18.9571 8.69867C19.1224 9.0379 19.1648 9.4087 19.0812 9.76597C18.9975 10.1238 18.7896 10.4577 18.4774 10.723C18.165 10.9886 17.7633 11.1722 17.322 11.2468C16.8807 11.3215 16.4236 11.283 16.0094 11.1372C15.5953 10.9913 15.2463 10.7461 15.0032 10.4369C14.7607 10.1285 14.6341 9.76993 14.634 9.40667C14.6359 8.92045 14.8638 8.4466 15.2818 8.09129C15.7008 7.73513 16.2745 7.53008 16.8788 7.52841ZM3.46736 14.7555C3.46736 14.1938 3.72961 13.6471 4.21048 13.2383C4.69234 12.8288 5.35191 12.5944 6.04514 12.5944H11.6007C12.2939 12.5944 12.9535 12.8288 13.4353 13.2383C13.9162 13.6471 14.1785 14.1938 14.1785 14.7555V18.8055H3.46736V14.7555Z" fill="currentColor" stroke="currentColor" stroke-width="0.4"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1238_3876">
                      <rect width="24" height="20.4" fill="white" transform="translate(0.15625 0.399902)"/>
                    </clipPath>
                  </defs>
                </svg>
                <span class="list__item-name">{{ propertyValue.Occupied ? 'Ocupado' : 'No Ocupado' }}</span>
              </div>
              <div class="property__features__list-item">
                <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1252_4438)">
                  <path d="M19.4041 20.7998H4.90806C3.61206 20.7998 2.55606 19.7438 2.55606 18.4478V8.72783L1.27206 8.64383C0.744055 8.60783 0.300055 8.22383 0.180055 7.70783C0.060055 7.19183 0.300055 6.65183 0.768055 6.39983L11.0281 0.699832C11.7361 0.303832 12.5761 0.303832 13.2841 0.699832L23.5441 6.39983C24.0121 6.66383 24.2521 7.19183 24.1321 7.70783C24.0121 8.22383 23.5681 8.60783 23.0401 8.64383L21.7561 8.72783V18.4598C21.7561 19.7558 20.7001 20.8118 19.4041 20.8118V20.7998ZM4.74006 6.91583C4.87206 7.10783 4.95606 7.34783 4.95606 7.59983V18.4598L19.4041 18.4118L19.3561 7.61183C19.3561 7.35983 19.4281 7.13183 19.5601 6.93983L12.1201 2.78783L4.74006 6.91583Z" fill="#D6C1F5"/>
                  <path d="M13.3561 20.7998C12.6961 20.7998 12.1561 20.2598 12.1561 19.5998C12.1561 20.2598 11.6161 20.7998 10.9561 20.7998C10.2961 20.7998 9.75605 20.2598 9.75605 19.5998V15.3998C9.75605 14.4038 10.5601 13.5998 11.5561 13.5998H12.7561C13.7521 13.5998 14.5561 14.4038 14.5561 15.3998V19.5998C14.5561 20.2598 14.0161 20.7998 13.3561 20.7998Z" fill="#D6C1F5"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1252_4438">
                    <rect width="24" height="20.4" fill="white" transform="translate(0.15625 0.399902)"/>
                    </clipPath>
                  </defs>
                </svg>
                <span class="list__item-name">Uso mixto</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero__background  d-none d-lg-block d-xl-block">
        <button type="button" class="btn more-images" data-toggle="modal" data-target="#exampleModal">
          Ver Imágenes
        </button>
        <img class="hero__image" :src="propertyValue.img" alt="594 Columbia Ave" />
      </div>
    </div>
    <div class="container-fluid content__property">
      <div class="widget__info d-xl-none d-lg-none d-block" >
          <div class="widget__info-price">
            <div class="widget__price-title">
              <span>Precio Inicial</span>
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
              </svg>
            </div>
            <span class="price">${{ propertyValue.startPrice }}</span>
          </div>
          <div class="widget__content">
            <div class="widget__item">
              <div class="widget__item-title">
                <span>TIR Proyectada</span>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                  <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
                </svg>
              </div>
              <span class="widget__item-value">{{ propertyValue.projIRR }}%</span>
            </div>
            <div class="widget__item">
              <div class="widget__item-title">
                <span>Rendimiento sobre capital invertido</span>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                  <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
                </svg>
              </div>
              <span class="widget__item-value">{{ propertyValue.coc }}%</span>
            </div>
          </div>
          <div class="widget__ctas">
            <a :href="propertyValue.linkBuy" class="cta__buy">
              Compra
            </a>
            <a :href="propertyValue.linkSell" class="cta__sell">Venta</a>
          </div>
        </div>
      <div class="content__body">
        <Tabs :property="property" v-if="property" />
      </div>
      <aside class="content__sidebar d-none d-lg-block d-xl-block">
        <div class="widget__info">
          <div class="widget__info-price">
            <div class="widget__price-title">
              <span>Precio Inicial</span>
              <span data-toggle="tooltip" data-placement="top" :title="tootTipStartingPrice" class="tooltip-hover">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                  <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
                </svg>
              </span>
            </div>
            <span class="price">${{ propertyValue.startPrice }}</span>
          </div>
          <div class="widget__content">
            <div class="widget__item">
              <div class="widget__item-title">
                <span>TIR Proyectada</span>
                <span data-toggle="tooltip" data-placement="top" :title="tootTipProjecteIRR" class="tooltip-hover">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                    <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
                  </svg>
                </span>
              </div>
              <span class="widget__item-value">{{ propertyValue.projIRR }}%</span>
            </div>
            <div class="widget__item">
              <div class="widget__item-title">
                <span>Rendimiento Sobre Capital Invertido</span>
                <span data-toggle="tooltip" data-placement="top" :title="tootTipCocReturn" class="tooltip-hover">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.532715" y="0.5" width="22" height="22" rx="11" fill="#D4CAE3"/>
                    <path d="M11.9937 13.2969H10.5405C10.5457 12.7969 10.59 12.388 10.6733 12.0703C10.7619 11.7474 10.9051 11.4531 11.103 11.1875C11.3009 10.9219 11.564 10.6198 11.8921 10.2812C12.1317 10.0365 12.3504 9.80729 12.5483 9.59375C12.7515 9.375 12.9155 9.14062 13.0405 8.89062C13.1655 8.63542 13.228 8.33073 13.228 7.97656C13.228 7.61719 13.1629 7.30729 13.0327 7.04688C12.9077 6.78646 12.7202 6.58594 12.4702 6.44531C12.2254 6.30469 11.9207 6.23438 11.5562 6.23438C11.2541 6.23438 10.9676 6.28906 10.6968 6.39844C10.4259 6.50781 10.2072 6.67708 10.0405 6.90625C9.87386 7.13021 9.78792 7.42448 9.78271 7.78906H8.3374C8.34782 7.20052 8.49365 6.69531 8.7749 6.27344C9.06136 5.85156 9.44678 5.52865 9.93115 5.30469C10.4155 5.08073 10.9572 4.96875 11.5562 4.96875C12.2176 4.96875 12.7801 5.08854 13.2437 5.32812C13.7124 5.56771 14.0692 5.91146 14.314 6.35938C14.5588 6.80208 14.6812 7.32812 14.6812 7.9375C14.6812 8.40625 14.5848 8.83854 14.3921 9.23438C14.2046 9.625 13.9624 9.99219 13.6655 10.3359C13.3687 10.6797 13.0535 11.0078 12.7202 11.3203C12.4338 11.5859 12.241 11.8854 12.1421 12.2188C12.0431 12.5521 11.9937 12.9115 11.9937 13.2969ZM10.478 15.7734C10.478 15.5391 10.5509 15.3411 10.6968 15.1797C10.8426 15.0182 11.0535 14.9375 11.3296 14.9375C11.6108 14.9375 11.8244 15.0182 11.9702 15.1797C12.116 15.3411 12.189 15.5391 12.189 15.7734C12.189 15.9974 12.116 16.1901 11.9702 16.3516C11.8244 16.513 11.6108 16.5938 11.3296 16.5938C11.0535 16.5938 10.8426 16.513 10.6968 16.3516C10.5509 16.1901 10.478 15.9974 10.478 15.7734Z" fill="#351467"/>
                  </svg>
                </span>
              </div>
              <span class="widget__item-value">{{ propertyValue.coc }}%</span>
            </div>
          </div>
          <div class="widget__ctas tooltip-hover">
            <a :href="propertyValue.linkBuy" class="cta__buy">
              Compra
            </a>
            <a :href="propertyValue.linkSell" class="cta__sell tooltip-hover">Venta</a>
          </div>
        </div>
      </aside>
    </div>    

    <!-- Modal -->
    <Carrousel :property="property.attributes.Images"></Carrousel>
    <footer-info></footer-info>
  </home-layout>
</template>
<style lang="scss">
.more-images {
  position: absolute;
  width: 183px;
  height: 38px;
  top: 19px;
  /* left: 0; */
  right: 20px;
  padding: 8px, 16px, 8px, 16px;
  border-radius: 10px;
  gap: 10px;
  color:#DEFBEC;
  background: #00000080;
}
.tooltip-hover { cursor: pointer; }
section .content-item {
  width: 80%;
  left: 10%;
  bottom: 10%;
}
section .modal-layer {
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: block;
}
section .modal-layer .slide-img {
  background-image: url(https://i1.sndcdn.com/artworks-YxGUGES6DrzzCUGx-Gx32ZQ-t240x240.jpg);
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
</style>
<script>
import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import Carrousel from '@/components/Carrousel'
import Tabs from '@/components/Tabs'
import { getPropertyDetail, getPropertyTooltips } from "@/services/property";
export default {
  name: 'Detail',
  props: {
  },
  data () {
    return {
      images:[],
      tootTipStartingPrice:'',
      tootTipProjecteIRR:'',
      tootTipCocReturn:'',
      property:null,
      propertyValue: {
        img: '',
        title: '',
        subtitle: '',
        description: '',
        irr:'',
        coc:'',
        add:'',
        startPrice:0,
        tokenPrice: null,
        capRate: null,
        projAppreciation: null,
        projIRR: 0,
        tokenSold: false,
        isFeatured: false,
        isNewListening: null,
        size: 0,
        Details:'',
        Occupied: false,
        titleLocation: '',
        Status:false,
        linkSell:'',
        linkBuy: ''
      },
      valorDeveloper: {
        img: '',
        title: '',
        subtitle: '',
        description: ''
      }
    }
  },
  methods: {
    deleteStyle () {
      this.changeStyle = ''
    },
    setStyle () {
      this.changeStyle = 'background-color: #0D051A;'
    },
    changeInvestorValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales1
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales4
      }
      this.valorDeveloper.title = this.valorInvestorAll[value].title
      this.valorDeveloper.subtitle = this.valorInvestorAll[value].subtitle
      this.valorDeveloper.description = this.valorInvestorAll[value].description
    },
    changeDeveloperValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales4
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales1
      }
      this.valorDeveloper.title = this.valorDeveloperAll[value].title
      this.valorDeveloper.subtitle = this.valorDeveloperAll[value].subtitle
      this.valorDeveloper.description = this.valorDeveloperAll[value].description
    },
    changeSubOption (value) {
      this.validateSubOption= value
      if (this.valiteOption) {
        this.changeInvestorValue(value)
      } else {
        this.changeDeveloperValue(value)
      }
    },
    changeOption (value) {
      this.valiteOption = value
      if (value) {
        this.changeSubOption(0)
        this.changeInvestorValue(0)
      } else {
        this.changeSubOption(0)
        this.changeDeveloperValue(0)
      }
    } 
  }
  ,
  created () {
    getPropertyTooltips().then(response => {
      console.log(response.data.data.attributes)
      this.tootTipStartingPrice = response.data.data.attributes.StartingPrice
      this.tootTipProjecteIRR = response.data.data.attributes.ProjecteIRR
      this.tootTipCocReturn = response.data.data.attributes.CocReturn
    })
    getPropertyDetail(this.$route.params.slug).then((response) => { 
        console.log("response Property", response.data.data[0].attributes)
        this.property =  response.data.data[0]
        this.images = response.data.data[0].attributes.Images.data
        if(this.property.attributes.Images.data[0].attributes.formats.medium) {
          this.propertyValue.img = this.property.attributes.Images.data[0].attributes.formats.medium.url
        }
        else if(this.property.attributes.Images.data[0].attributes.formats.small) {
          this.propertyValue.img = this.property.attributes.Images.data[0].attributes.formats.small.url
        }
        else {
          this.propertyValue.img = this.property.attributes.Images.data[0].attributes.url
        }
        
        this.propertyValue.title = this.property.attributes.Name
        this.propertyValue.irr = this.property.attributes.property_financial.data.attributes.IRR
        this.propertyValue.coc = this.property.attributes.property_financial.data.attributes.Coc
        this.propertyValue.add = this.property.attributes.Address
        this.propertyValue.tokenPrice = this.property.attributes.property_financial.data.attributes.tokenPrice
        this.propertyValue.capRate = this.property.attributes.property_financial.data.attributes.capRate
        this.propertyValue.projAppreciation = this.property.attributes.property_financial.data.attributes.projAppreciation
        this.propertyValue.projIRR = this.property.attributes.property_financial.data.attributes.ProjIRR
        this.propertyValue.tokenSold = this.property.attributes.property_financial.data.attributes.tokenSold
        this.propertyValue.isFeatured = this.property.attributes.isFeatured
        this.propertyValue.isNewListening = this.property.attributes.isNewListening
        this.propertyValue.slug = this.property.attributes.slug
        this.propertyValue.size = this.property.attributes.Size
        this.propertyValue.startPrice = this.property.attributes.property_financial.data.attributes.StartPrice
        console.log('this.propertyValue.startPrice', this.propertyValue.startPrice)
        this.propertyValue.Occupied = this.property.attributes.Occupied
        this.propertyValue.titleLocation = this.property.attributes.titleLocation
        this.propertyValue.Status = this.property.attributes.Status
        this.propertyValue.linkBuy = this.property.attributes.LinkBuy
        this.propertyValue.linkSell = this.property.attributes.LinkSell
      })
  },
  mounted () {
    
  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo,
    Tabs,
    Carrousel
  }
}
</script>
